module.exports = __webpack_public_path__ + "img/imgzhuy-xz.79b5dfd9.png";